// ======================================================================
// FILE:
// src/modules/service_crm/feedback/pages/FeedbackListPage.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Customer Feedback Queue
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import serviceFeedbackService
from "../services/serviceFeedbackService";

import FeedbackKpiBar
from "../components/FeedbackKpiBar";

import FeedbackFilterBar
from "../components/FeedbackFilterBar";

import FeedbackTable
from "../components/FeedbackTable";

import FeedbackFormDrawer
from "../components/FeedbackFormDrawer";

export default function FeedbackListPage() {

  const [loading, setLoading] =
    useState(false);

  const [rows, setRows] =
    useState([]);

  const [filters, setFilters] =
    useState({});

  const [selectedTicket,
    setSelectedTicket] =
    useState(null);

  const [drawerOpen,
    setDrawerOpen] =
    useState(false);

  const [drawerMode,
    setDrawerMode] =
    useState("add");

  // ==========================================================
  // LOAD
  // ==========================================================

  useEffect(() => {

    loadData();

  }, [filters]);

  async function loadData() {

    try {

      setLoading(true);

      const response =
        await serviceFeedbackService
          .getFeedbackQueue(
            filters
          );

      setRows(

        response?.data || []

      );

    } catch (err) {

      console.error(err);

      alert(
        "Failed to load feedback queue"
      );

    } finally {

      setLoading(false);

    }
  }

  // ==========================================================
  // FILTER
  // ==========================================================

  function handleApplyFilters(
    values
  ) {

    setFilters(
      values
    );
  }

  // ==========================================================
  // DRAWER
  // ==========================================================

  function handleAdd(row) {

    setSelectedTicket(
      row
    );

    setDrawerMode(
      "add"
    );

    setDrawerOpen(
      true
    );
  }

  function handleEdit(row) {

    setSelectedTicket(
      row
    );

    setDrawerMode(
      "edit"
    );

    setDrawerOpen(
      true
    );
  }

  function handleView(row) {

    setSelectedTicket(
      row
    );

    setDrawerMode(
      "view"
    );

    setDrawerOpen(
      true
    );
  }

  function closeDrawer() {

    setDrawerOpen(
      false
    );

    setSelectedTicket(
      null
    );
  }

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div
      className="container-fluid"
    >

      {/* HEADER */}

      <div
        style={{
          marginBottom: 20,
        }}
      >

        <h2
          style={{
            marginBottom: 4,
          }}
        >
          Customer Feedback
        </h2>

        <div
          style={{
            color: "#6c757d",
          }}
        >
          Feedback collection queue for
          resolved service tickets
        </div>

      </div>

      {/* KPI */}

      <FeedbackKpiBar
        rows={rows}
      />

      {/* FILTERS */}

      <FeedbackFilterBar
        filters={filters}
        onApply={
          handleApplyFilters
        }
      />

      {/* TABLE */}

      <FeedbackTable

        rows={rows}

        loading={loading}

        onAdd={
          handleAdd
        }

        onEdit={
          handleEdit
        }

        onView={
          handleView
        }

      />

      {/* DRAWER */}

      <FeedbackFormDrawer

        open={
          drawerOpen
        }

        mode={
          drawerMode
        }

        ticket={
          selectedTicket
        }

        onClose={
          closeDrawer
        }

        onSaved={() => {

          loadData();

        }}

      />

    </div>
  );
}